<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        :back-link-url="`/acceptance/list/${projectId}`">
      </f7-nav-left>
      <f7-nav-title>验工申请</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="add">保存</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="has-content">
      <f7-list inline-labels id="acceptForm">
        <f7-list-input
          label="节点部位"
          type="text"
          :value="acceptanceApply.title"
          @input="acceptanceApply.title = $event.target.value"
          placeholder="请填写"
          required
          validate
          error-message='必填项，长度2-50字符'
          minlength=2
          maxlength=50>
          <div slot="media" class="input-required">*</div>
        </f7-list-input>
        <f7-list-input
          label="报验数量"
          type="number"
          :value="acceptanceApply.count"
          @input="acceptanceApply.count = $event.target.value"
          placeholder="请填写"
          validate
          error-message='必须大于0且小于10000000'
          min=0
          max=10000000>
          <div slot="media" class="input-required">&nbsp;</div>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">验收预约时间</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            readonly
            required
            id="picker-appointment" />
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">&nbsp;</div>
          <div slot="label">任务是否全部完工</div>
          <f7-toggle
            slot="inner"
            @toggle:change="toggleFinished"
            color="orange">
          </f7-toggle>
        </f7-list-input>
        <f7-list-input
          label="验收说明"
          type="textarea"
          :value="acceptanceApply.remark"
          @input="acceptanceApply.remark = $event.target.value"
          placeholder="请填写"
          required
          validate
          error-message='必填项，长度2-500字符'
          minlength=2
          maxlength=500
          resizable>
          <div slot="media" class="input-required">*</div>
        </f7-list-input>
      </f7-list>
      <div class="img-show-area">
        <div class="img-show" v-for="file in files" :key="file.id">
          <img v-if="file.thumb" :src="file.thumb" width="100%" height="100%" />
          <span v-else>无图片</span>
          <div class="img-show-close" @click="removeFile(file)">
            <f7-icon fa="times" size="1rem"></f7-icon>
          </div>
        </div>
        <div class="img-show">
          <file-upload
            class="file-upload"
            input-id="acceptanceFile"
            :post-action="uploadURL"
            :extensions="extensions"
            :accept="accept"
            :multiple="multiple"
            :size="size || 0"
            :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
            :add-index="addIndex"
            v-model="files"
            @input-filter="inputFilter"
            ref="acceptanceUpload">
            <f7-icon fa="plus" size="1rem"></f7-icon>
          </file-upload>
        </div>
        <div
          class="img-show"
          v-if="(files.length + 1) % 3 > 0 && (files.length + 1) % 3 <= 1">
        </div>
        <div
          class="img-show"
          v-if="(files.length + 1) % 3 > 0 && (files.length + 1) % 3 <= 2">
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import lodash from 'lodash';
import { getDict, imageView, uploadFileUrl } from '@/api/common';
import { applyAcceptance } from '@/api/acceptance';
import { createPickerTime, createToast } from '@/util/compUtils';
import { AcceptanceApply } from '@/model/reqObject';
import FileUpload from 'vue-upload-component';

export default {
  props: ['projectId'],
  components: {
    FileUpload,
  },
  data() {
    return {
      imageUrl: imageView,
      yesNoList: [],
      acceptanceApply: new AcceptanceApply({ projectId: this.projectId }),
      files: [],
      accept: 'image/png,image/gif,image/jpeg,image/webp',
      extensions: 'gif,jpg,jpeg,png,webp',
      minSize: 1024,
      size: 1024 * 1024 * 10,
      multiple: true,
      addIndex: false,
      thread: 3,
      name: 'file',
      uploadURL: uploadFileUrl,
      flag: true,
    };
  },
  mounted() {
    const dictKeys = ['yesNo'];
    getDict({ typeCodes: dictKeys }).then((result) => {
      this.yesNoList = result.data.yesNo.codeVoList || [];
    });
    this.init();

    this.$watch(
      () => this.flag && this.files.length !== 0
        && this.$refs.acceptanceUpload && this.$refs.acceptanceUpload.uploaded,
      (newVal) => {
        if (newVal) {
          this.addObj();
        }
      },
    );
  },
  methods: {
    add() {
      this.flag = false;
      let valided = true;
      // this.$f7.input.validateInputs('#acceptForm');
      this.$$('#acceptForm').find('input, textarea, select').forEach((inputEl) => {
        valided = valided && !this.$$(inputEl).hasClass('input-invalid');
      });
      if (valided &&
        (this.files.length === 0
          || (this.$refs.acceptanceUpload && this.$refs.acceptanceUpload.uploaded))) {
        this.addObj();
      } else if (valided && this.files.length > 0) {
        this.$f7.dialog.preloader('正在上传数据');
        this.$refs.acceptanceUpload.active = true;
        this.flag = true;
      }
    },

    addObj() {
      let uploadValid = true;
      const fileIdList = [];
      this.files.forEach((file) => {
        uploadValid = uploadValid && (file.response.code === 0);
        if (file.response.code === 0) {
          fileIdList.push(file.response.data.id);
        }
      });
      if (uploadValid) {
        this.$set(this.acceptanceApply, 'attachmentIdList', lodash.uniq(fileIdList));
        applyAcceptance(this.acceptanceApply).then((result) => {
          this.$f7.dialog.close();
          if (result.code === 0) {
            createToast(this, '申请成功');
            this.$f7router.back(`/acceptance/list/${this.projectId}`);
          }
        });
      }
    },
    init() {
      createPickerTime(this, '#picker-appointment', 'acceptanceApply', 'acceptanceTime');
    },
    toggleFinished(e) {
      this.$set(this.acceptanceApply, 'finished', e ? '1' : '0');
    },
    removeFile(oldFile) {
      if (this.files.includes(oldFile)) {
        this.files.splice(this.files.findIndex(item => item.id === oldFile.id), 1);
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        Object.assign(newFile, { blob: '' });
        const URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          Object.assign(newFile, { blob: URL.createObjectURL(newFile.file) });
        }
        Object.assign(newFile, { thumb: '' });
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          Object.assign(newFile, { thumb: newFile.blob });
        }
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .img-show-area {
    border-top: 0.05rem solid $border-color;
    text-align: center;
    padding: 1rem 0rem;
    display: flex;
    flex-flow:row wrap;
    align-items: flex-start;
    justify-content: space-around;
  }

  .img-show {
    width: 30%;
    height: 6rem;
    padding: 0.5rem 0rem;
    position: relative;
  }

  .img-show-close {
    color: $white-color;
    height: 1rem;
    width: 1rem;
    line-height: 1rem;
    position: absolute;
    right: 0rem;
    top: 0.5rem;
    text-align: center;
    background-color: $theme-color;
    cursor: pointer;
  }

  .file-upload {
    background-color: $panel-bg-color;
    border-radius: 0.5rem;
    width: 100%;
    height: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .input-required {
    padding-left: 0.5rem;
    padding-top: 0.4rem;
    color: #FF0000;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/acceptance/add.vue